import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  prefixCurriculumName,
  setSubChildId,
} from "Administrator/modules/AdministratorModule";
import SubjectGradeScale from "Administrator/routes/MYPAcademicSetup/routes/LocalGrades/routes/SubjectGradeScale";
import { getSelectedCurriculumId } from "modules/CommonSelectors";
import { LOCAL_GRADE_SETUP } from "Constants/stringConstants";
export default store => ({
  path: "local-grade-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Administrator/commonComponents/LocalGrades/components"
        ),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Administrator/routes/MYPAcademicSetup/routes/LocalGrades/modules/LocalGradesModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "localGrades",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    const state = store.getState();
    const curriculumProgramId = getSelectedCurriculumId(state);
    const childId = store.dispatch(
      prefixCurriculumName({
        childId: LOCAL_GRADE_SETUP,
        curriculumProgramId,
      })
    );
    store.dispatch(setSubChildId(childId));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
  childRoutes: [SubjectGradeScale(store)],
});
